<template>
    <div class="revative">
        <div class="slider-hero">
            <!-- <slide-hero-item />
            <slide-hero-item2 /> -->

        </div>
    </div>

    <!-- <button type="button" class="flex absolute top-0 left-0 z-30 justify-center items-center px-4 h-full cursor-pointer group focus:outline-none" data-carousel-prev="">
        <span class="inline-flex justify-center items-center w-8 h-8 rounded-full border border-white hover:border-indigo-600 hover:bg-indigo-600 group-focus:outline-none">
            <span class="material-icons text-white">keyboard_arrow_left</span>
            <span class="hidden">Previous</span>
        </span>
    </button>
    <button type="button" class="flex absolute top-0 right-0 z-30 justify-center items-center px-4 h-full cursor-pointer group focus:outline-none" data-carousel-next="">
        <span class="inline-flex justify-center items-center w-8 h-8 rounded-full border border-white hover:border-indigo-600 hover:bg-indigo-600 group-focus:outline-none">
            <span class="material-icons text-white">keyboard_arrow_right</span>
            <span class="hidden">Next</span>
        </span>
    </button> -->
</template>

<script>
import { tns } from "tiny-slider";
import "tiny-slider/dist/tiny-slider.css";
import SlideHeroItem2 from "./SlideHeroItem2.vue";
import SlideHeroItem from "./SlideHeroItem.vue";

export default {
    components: { SlideHeroItem2,SlideHeroItem },
    mounted() {
        const slider = tns({
            container: ".slider-hero",
            items: 1,
            mode: "carousel",
            loop: true,
            controls: false,
            controlsText: ['<span class="hidden">Previous</span>', '<span class="hidden">Next</span>'],
            nav: false,
            swipeAngle: false,
            rewind: true,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            navPosition: "bottom",
            speed: 400,
            responsive: {},
        });
    },
};
</script>

<style></style>
